import React from 'react';

import { ContentGroup, Heading, Main } from '@constellation/core';
import { useContent } from '@interstellar/react-app-content';
import MetaTags from 'client/components/metaTags/MetaTags';

import { LimitedCompanyLaunchContent } from './LimitedCompanyLaunch.config';

function LimitedCompanyLaunchPage(): React.JSX.Element {
  const { metaContent, pageTitle } = useContent<LimitedCompanyLaunchContent>();

  return (
    <Main>
      <MetaTags metaContent={metaContent} />

      <ContentGroup marginTop="05">
        <Heading as="h1" size="s7">
          {pageTitle}
        </Heading>
      </ContentGroup>
    </Main>
  );
}

export default LimitedCompanyLaunchPage;
